import { render, staticRenderFns } from "./EditBid.vue?vue&type=template&id=5018d961"
import script from "./EditBid.vue?vue&type=script&lang=js"
export * from "./EditBid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports